import { addIssue } from './add-issue';
import { z } from 'zod';
import { hasEmptyPrice, isValidNumber } from './common';
import { getRequiredYears } from './getRequiredYears';

export const validateEnergyPrices = ({
  rawPriceList,
  basePath,
  ctx,
  energyPricesProjection,
  supplyStartDate,
  supplyFinalDate,
  globalSupplyStartDate,
  globalSupplyFinalDate,
  aux__useDifferentPeriodsByUnit,
}: {
  rawPriceList: Record<string, any> | undefined | null;
  basePath: Array<string | number>;
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  };
  energyPricesProjection?: Record<string, number> | null;
  supplyStartDate?: string | null | Date;
  supplyFinalDate?: string | null | Date;
  globalSupplyStartDate?: string | null | Date;
  globalSupplyFinalDate?: string | null | Date;
  aux__useDifferentPeriodsByUnit?: boolean;
}): boolean => {
  let hasErrors = false;

  if (!rawPriceList) {
    addIssue(ctx, [...basePath], 'Preços de energia são obrigatórios');
    return false;
  }

  const requiredYears = getRequiredYears(
    supplyStartDate,
    supplyFinalDate,
    globalSupplyStartDate,
    globalSupplyFinalDate,
    aux__useDifferentPeriodsByUnit,
  );

  if (requiredYears.length === 0) {
    const projKeys: string[] = [];
    if (energyPricesProjection && typeof energyPricesProjection === 'object') {
      Object.keys(energyPricesProjection).forEach((k) => {
        projKeys.push(k.startsWith('year') ? k : `year${k}`);
      });
    }

    if (projKeys.length > 0) {
      requiredYears.push(...projKeys);
      if (basePath.some((p) => typeof p === 'string' && p.includes('targetScenarios'))) {
        addIssue(ctx, [...basePath], 'Não foi possível determinar os anos necessários para validação');
        return false;
      }
    }
  }

  requiredYears.forEach((year) => {
    const price = rawPriceList[year];

    if (hasEmptyPrice(price)) {
      addIssue(ctx, [...basePath, year], `Preço de energia para ${year.replace('year', '')} é obrigatório`);
      hasErrors = true;
    } else if (isValidNumber(price)) {
      addIssue(
        ctx,
        [...basePath, year],
        `Preço de energia para ${year.replace('year', '')} deve ser um número válido maior ou igual a zero`,
      );
      hasErrors = true;
    }
  });

  return !hasErrors;
};
